<app-smart-table
    [tableHeaderAndData]="tableData"
    [allowPagination]="false"
    [firstColumnIsSticky]="false"
    [customContentTemplate]="remarkTemplate"
    i18n-emptyTableText
    emptyTableText="No validation entries."
>
    <ng-template #remarkTemplate let-row="row" let-key="key">
        <div *ngIf="key === 'remark' && row?.remark?.rawData?.isError" class="flex items-center gap-1">
            <iota-icon icon="exclamation-triangle" class="text-warning" size="1.2" variation="solid"></iota-icon>
            <span>{{ row?.remark?.rawData?.label }}</span>
        </div>
    </ng-template>
</app-smart-table>
